import { VC_BOARD_TYPES } from 'constants/general';
import { VALUE_CHAIN_PRODUCT_TYPES, VALUE_CHAIN_UNIT_TYPES } from 'constants/interfaces';

import type IOption from 'components/MappingModal/interfaces/IOption';

export const PRODUCT_TYPE_OPTIONS: IOption[] = [
  {
    value: VALUE_CHAIN_PRODUCT_TYPES.INPUT,
    label: VALUE_CHAIN_PRODUCT_TYPES.INPUT,
  },
  {
    value: VALUE_CHAIN_PRODUCT_TYPES.OUTPUT,
    label: VALUE_CHAIN_PRODUCT_TYPES.OUTPUT,
  },
];

export const getProductTypeByValueChain = (valueChainList?: string): string | null => {
  if (valueChainList === VC_BOARD_TYPES.UPSTREAM) {
    return VALUE_CHAIN_PRODUCT_TYPES.INPUT;
  }

  if (valueChainList === VC_BOARD_TYPES.OWN_OPERATIONS) {
    return VALUE_CHAIN_PRODUCT_TYPES.OUTPUT;
  }

  return null;
};

// Input products are linked to the suppliers that provide them, output products to the
// balance sheet assets that manufacture them. Product type is the authoritative anchor —
// the value chain board is derived from it and can be absent in some record contexts.
export const getRelationTypeByProductType = (productType?: string | null): string | null => {
  if (productType === VALUE_CHAIN_PRODUCT_TYPES.INPUT) {
    return VALUE_CHAIN_UNIT_TYPES.SUPPLIER;
  }

  if (productType === VALUE_CHAIN_PRODUCT_TYPES.OUTPUT) {
    return VALUE_CHAIN_UNIT_TYPES.BALANCE_SHEET_ASSET;
  }

  return null;
};

export const getRelationTypeByValueChain = (valueChainList?: string): string | null => (
  getRelationTypeByProductType(getProductTypeByValueChain(valueChainList))
);

export const getProductTypeOption = (productType?: string | null): IOption | undefined => {
  if (!productType) {
    return undefined;
  }

  return PRODUCT_TYPE_OPTIONS.find(({ value }) => value === productType);
};

export const getProductTypeOptionByValueChain = (valueChainList?: string): IOption | undefined => (
  getProductTypeOption(getProductTypeByValueChain(valueChainList))
);

export const getValueChainByProductType = (productType?: string): string | undefined => {
  if (productType === VALUE_CHAIN_PRODUCT_TYPES.INPUT) {
    return VC_BOARD_TYPES.UPSTREAM;
  }

  if (productType === VALUE_CHAIN_PRODUCT_TYPES.OUTPUT) {
    return VC_BOARD_TYPES.OWN_OPERATIONS;
  }

  return undefined;
};
